import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

import Rating from "@material-ui/lab/Rating";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import LineBreak from "@components/Global/Custom/Icons/LineBreak";

const WebsiteReviews = () => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const limit = 3;
	const header = `Recent reviews`;
	const subHeader = `Rated 4.8 out of 921 reviews`;
	const tagline = "";
	const textAlign = "center";
	const lineBreak = true;
	const content = "";

	const reviews = [
		{
			id: 1,
			rating: 5.0,

			detail:
				"Our Reggio Emilia-inspired curriculum, Creatively Shine®, is based on the latest research and trends to prepare your children for their educational careers equipping them with cognitive, social, emotional, physical and language skills. Our Reggio Emilia-inspired curriculum, Creatively Shine®, is based on the latest research and trends to prepare your children for their educational careers equipping them with cognitive, social, emotional, physical and language skills.",
			author: "Troy H.",
			location: "Austin, TX",
		},
		{
			id: 2,
			rating: 4.5,

			detail:
				"The different classes that are also available to you is amazing. I absolutely picked the right company to tutor me. Highly recommended.",
			author: "Fave H.",
			location: "Austin, TX",
		},
		{
			id: 3,
			rating: 5.0,

			detail:
				"The different classes that are also available to you is amazing. I absolutely picked the right company to tutor me. Highly recommended.",
			author: "Mika H.",
			location: "Austin, TX",
		},
	];

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={8}
							justifyContent="center"
							alignItems={textAlign}
						>
							<Grid item xs={12}>
								<Box
									display={"flex"}
									flexDirection={"column"}
									justifyContent={"center"}
									alignItems={textAlign}
									height={"100%"}
								>
									{tagline && (
										<Box className="tagline" textAlign={textAlign}>
											{tagline}
										</Box>
									)}

									{header && (
										<Box component={"h2"} textAlign={textAlign}>
											{header ? header : "Recent reviews"}
										</Box>
									)}

									{subHeader && (
										<Box component={"h3"} textAlign={textAlign}>
											{subHeader}
										</Box>
									)}

									{lineBreak && (
										<Box my={1} textAlign={textAlign}>
											<LineBreak className={classes.lineBreak} />
										</Box>
									)}

									{content && (
										<>
											<Box component={"p"} textAlign={textAlign}>
												{content}
											</Box>
										</>
									)}

									<Grid container spacing={6}>
										{reviews.slice(0, limit).map((review) => (
											<Grid item xs={12} md={4} key={review.id}>
												<div className={classes.reviewsBox}>
													<Rating
														value={review.rating}
														precision={0.5}
														readOnly
														size="large"
														classes={{ iconFilled: classes.stars }}
													/>

													<div className={classes.reviewsBody}>
														{review.detail}
													</div>

													<div className={classes.reviewsCustomer}>
														<div>
															<img
																src={`//static.lessons.com/assets/images/letters/${review.author[0]}.png`}
																alt={""}
																className={classes.reviewsCustomerImg}
															/>
														</div>
														<div>
															<div className={classes.reviewsAuthor}>
																{review.author}
															</div>
															<div className={classes.reviewsLocation}>
																{review.location}
															</div>
														</div>
													</div>
												</div>
											</Grid>
										))}
									</Grid>

									<Box
										mt={15}
										textAlign={textAlign}
										justifyContent={textAlign}
										width="100%"
									>
										<Button
											size="large"
											color="primary"
											variant="contained"
											disableElevation
											href="/go to reviews page"
											className="columnButton"
										>
											Read more reviews
										</Button>
									</Box>
								</Box>
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteReviews;
